module.exports = function(app) {
    app.factory('receiptRequiredSubmitService', ['$q', 'services',
        function($q, services) {

            var getData = function(receiptRequiredPayload) {

                return services.rbsmbl.receiptRequiredSubmit().fetch(receiptRequiredPayload).then(
                    function(response) {
                        return response;
                    },
                    function(err) {
                        console.error('fetch failed in getData', err);
                        return err;
                    }
                );
            };

            return {
                getData: getData
            };
        }
    ]);
};